import { render, staticRenderFns } from "./StrapiContactComponent.vue?vue&type=template&id=35f7f734"
import script from "./StrapiContactComponent.vue?vue&type=script&lang=js"
export * from "./StrapiContactComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports